(function(){
	

	const banner = () => {
		let banner = document.querySelector('.banner h1 a');
		
		if ( ! banner )
			return;

		// search for the split string
		let split_at = 'tidlig" ';
		if ( banner.innerText.indexOf(split_at) === -1 )
			return;

		let txt = banner.innerText.split(split_at);
		txt[0] += split_at; 
		
		for ( let i = 0; i < banner.childNodes.length; i++ ) {
			if ( banner.childNodes[i].nodeName !== "IMG" )
				banner.removeChild(banner.childNodes[i]);
		}

		// append the new text node
		banner.insertAdjacentHTML('beforeend', txt.join('<br>'));

	};
	
	if ( location.host.indexOf('alta.b') !== -1 )
		banner();

})();